import { useBreakpoints } from "@vueuse/core";
import { computed } from "vue";

const useMobileBreakpoint = (mobileBreakPoint?: number) => {
  const breakpoints = useBreakpoints({
    mobile: 0,
    desktop: mobileBreakPoint ?? 767,
  });
  const activeBreakpoint = breakpoints.active();
  const isMobile = computed(() => {
    return activeBreakpoint.value === "mobile";
  });
  return {
    isMobile,
  };
};

export default useMobileBreakpoint;
